/** Parse Jira/SQLite timestamps; SQLite's "YYYY-MM-DD HH:MM:SS" has no zone and is UTC. */
function parseTimestamp(dateStr: string | null | undefined): number {
  if (!dateStr) return NaN;
  const hasTz = /Z|[+-]\d{2}:?\d{2}$/.test(dateStr);
  return new Date(hasTz ? dateStr : `${dateStr.replace(' ', 'T')}Z`).getTime();
}

/** Compact relative time ("5m ago"); empty for missing/invalid dates, never negative. */
export function timeAgo(dateStr: string | null | undefined): string {
  const ts = parseTimestamp(dateStr);
  if (isNaN(ts)) return '';
  const mins = Math.floor((Date.now() - ts) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

/** Absolute local date/time for tooltips; empty for missing/invalid dates. */
export function formatDateTime(dateStr: string | null | undefined): string {
  const ts = parseTimestamp(dateStr);
  return isNaN(ts) ? '' : new Date(ts).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
